import React from "react";
import "../css/Hero404.css";

export const Hero404 = () => {
	return(
		<div className="hero404">
			<div className="page-container">				
        <section className="page-body">
					<div className="message404">
						<h4 className="h1 font-weight-bold">Oops</h4>
						<h4 className="h3 my-4">Something went wrong</h4>
						<p>Sorry about that, hmmm... probably a missing page or the link's incorrect.</p>
						<button type="button"  className="px-4 py-2 bg-slate-800 text-white rounded-lg hover:bg-slate-700 transition-colors font-medium shadow-sm py-2 btn-block">Back Home</button>
					</div>
					<img className="image404" alt="404" src="/img/pages/hero404.png"/>
				</section>
			</div>
		</div>
	);
}
